import React from 'react'
import {
  createTheme,
  adaptV4Theme,
  ThemeProvider,
} from '@material-ui/core/styles'
// import { blueGrey, amber } from '@material-ui/core/colors'

const theme = createTheme(
  adaptV4Theme({
    palette: {
      type: 'dark',
      primary: {
        main: '#cccccc',
        // light: '#F2CC85',
        // dark: '#F2A516',
      },
      secondary: {
        main: '#D5A72B',
        // dark: '#024059',
        // light: '#A5BFE3',
      },
      background: {
        paper: '#424242',
        default: '#424242',
      },
    },
  })
)

export default function CurrentTheme(props) {
  return <ThemeProvider theme={theme}>{props.children}</ThemeProvider>
}
